module.exports = __webpack_public_path__ + "static/media/timelapse.5a616640.mp4";